<div class="fb-result" *ngIf="sentWithSuccess">
  <img class="success-image" src="./assets/images/blue_check_icon.png">
  {{getString('feedbackSentWithSuccess')}}
  <br>
</div>
<div class="fb-form" *ngIf="!sentWithSuccess">
  <div class="text-container">
    {{getString(textStringKey)}}
  </div>
  <div class="inputs-container">
    <input class="name-input" type="text" (keyup)="nameUpdated($event)" [placeholder]="getString('name')+' ('+getString('optional')+')'">
    <input class="email-input" type="text" (input)="emailUpdated($event)" [placeholder]="getString('emailAddress')+' ('+getString('optional')+')'">
</div>
  <textarea class="fb-text-area" name="feedbackText" id="fbTextArea" (keyup)="textUpdated($event)"></textarea>
  <!-- <div class="rating">
    <span (click)="starClick(1)" class="star"><span *ngIf="rating < 1">☆</span><span class="filled" *ngIf="rating >= 1">★</span></span>
    <span (click)="starClick(2)" class="star"><span *ngIf="rating < 2">☆</span><span class="filled" *ngIf="rating >= 2">★</span></span>
    <span (click)="starClick(3)" class="star"><span *ngIf="rating < 3">☆</span><span class="filled" *ngIf="rating >= 3">★</span></span>
    <span (click)="starClick(4)" class="star"><span *ngIf="rating < 4">☆</span><span class="filled" *ngIf="rating >= 4">★</span></span>
    <span (click)="starClick(5)" class="star"><span *ngIf="rating < 5">☆</span><span class="filled" *ngIf="rating >= 5">★</span></span>
  </div> -->
  <button class="send-btn blue-button" type="button" (click)="sendClicked()">{{getString('send')}}</button>
  <span *ngIf="invalidEmail" class="error-message red-text">{{getString('invalidEmail')}}</span>
  <span *ngIf="emptyFields" class="error-message red-text">{{getString('cannotSendEmptyForm')}}</span>
</div>
